<script lang="ts" setup>
import PriceLayerForm from "@/data-views/forms/price_layer/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "PriceLayer",
  },
});
</script>

<template>
  <div>
    <PriceLayerForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
